import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  // Initialize cart from localStorage
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCart = localStorage.getItem('cart');
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) {
      console.error('Error loading cart from localStorage:', error);
      return [];
    }
  });

  // Save to localStorage whenever cart changes
  useEffect(() => {
    try {
      localStorage.setItem('cart', JSON.stringify(cartItems));
    } catch (error) {
      console.error('Error saving cart to localStorage:', error);
    }
  }, [cartItems]);

  // Add item to cart
// Add item to cart
const addToCart = (product, quantity = 1) => {
  setCartItems(prevItems => {
    const existingItem = prevItems.find(item => item._id === product._id);
    
    if (existingItem) {
      return prevItems.map(item =>
        item._id === product._id
          ? { ...item, quantity: item.quantity + quantity }
          : item
      );
    } else {
      return [...prevItems, { ...product, quantity }];
    }
  });
};

// Remove item from cart
const removeFromCart = (productId) => {
  setCartItems(prevItems => prevItems.filter(item => item._id !== productId));
};

// Update item quantity
const updateQuantity = (productId, newQuantity) => {
  if (newQuantity < 1) {
    removeFromCart(productId);
    return;
  }
  
  setCartItems(prevItems =>
    prevItems.map(item =>
      item._id === productId
        ? { ...item, quantity: newQuantity }
        : item
    )
  );
};



  // Clear entire cart
  const clearCart = () => {
    setCartItems([]);
      localStorage.removeItem('cart'); 
  };

  // Get cart totals
  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartCount = () => {
    return cartItems.reduce((count, item) => count + item.quantity, 0);
  };

  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartCount
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};